"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class AbstractCalculator {}
var _default = exports.default = AbstractCalculator;